var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#3956C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.5C11 11.8748 11.0281 11 14.5 11C17.9719 11 18 11.8748 18 14.5C18 17.1252 18.0111 18 14.5 18C10.9889 18 11 17.1252 11 14.5Z",
    stroke: "#3956C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 14.5C22 11.8748 22.0281 11 25.5 11C28.9719 11 29 11.8748 29 14.5C29 17.1252 29.0111 18 25.5 18C21.9889 18 22 17.1252 22 14.5Z",
    stroke: "#3956C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 25.5C11 22.8748 11.0281 22 14.5 22C17.9719 22 18 22.8748 18 25.5C18 28.1252 18.0111 29 14.5 29C10.9889 29 11 28.1252 11 25.5Z",
    stroke: "#3956C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 25.5C22 22.8748 22.0281 22 25.5 22C28.9719 22 29 22.8748 29 25.5C29 28.1252 29.0111 29 25.5 29C21.9889 29 22 28.1252 22 25.5Z",
    stroke: "#3956C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrid);
export default __webpack_public_path__ + "static/media/iconGrid.524327500cef02a1c5ed69b923acf283.svg";
export { ForwardRef as ReactComponent };